const l = (r, p) => {
  var s, c;
  const e = document.querySelectorAll('input[id="' + r + '"], textarea[id="' + r + '"]');
  if (e)
    for (let n = 0; n < e.length; n++) {
      const t = e[n], o = t.tagName === "TEXTAREA" ? (s = Object == null ? void 0 : Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")) == null ? void 0 : s.set : (c = Object == null ? void 0 : Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) == null ? void 0 : c.set;
      o == null || o.call(t, p);
      const u = new Event("input", { bubbles: !0 });
      t.dispatchEvent(u), t.focus();
    }
};
export {
  l as default
};
